export function initChaletNavigation() {
    document.querySelectorAll('.breadcrumb-container .right-content a').forEach(link => {
        link.addEventListener('click', event => {
            event.preventDefault();
            link.classList.toggle('open');
            document.querySelector('.site-search .container')?.classList.toggle('open');
            window.scrollTo({top: 0, behavior: 'smooth'});
        });
    });
}
